import { render, staticRenderFns } from "./LookVideo.vue?vue&type=template&id=1358e7d6&scoped=true"
import script from "./LookVideo.vue?vue&type=script&lang=js"
export * from "./LookVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1358e7d6",
  null
  
)

export default component.exports